export const ROLES: Record<RolesUnion, RolesUnion> = {
  clinic: 'clinic',
  image_center: 'image_center'
} as const
